import React from 'react';
import { Modal, Button } from 'antd';
import './LodestarIntegrationNotice.css';
import { useHistory } from 'react-router-dom';

const LodestarIntegrationNotice = ({ open, onClose, onEnable }) => {
    const history = useHistory();
    const handleEnable = () => {
        history.push('/app/management?select=estimatedclosingfee')
        onEnable()
    }
    return (
        <Modal
            open={open}
            footer={null}
            closable={true}
            onCancel={onClose}
            width={956}
            centered={true}
            className="lodestar-notice-modal"
            maskClosable={false}
        >
            <div className="lodestar-notice-content">
                <div className="lodestar-notice-title">Lodestar integration now available</div>
                <div className="lodestar-notice-description">
                    We've integrated Lodestar to deliver estimated closing cost data for all rate quotes—designed to support your workflow and client trust. You can also setup later in <span className="highlight">Management {'>'} Closing cost settings</span>.
                </div>
                <div className="lodestar-notice-image">
                    <img src="/images/lodestar-integration.svg" alt="Lodestar Integration" />
                </div>
                <div className="lodestar-notice-footer">
                    <div className="lodestar-notice-skip-button" onClick={onClose}>Skip</div>
                    <Button type="primary" className="lodestar-notice-enable-button" onClick={handleEnable}>Enable now</Button>
                </div>
            </div>
        </Modal>
    );
};

export default LodestarIntegrationNotice;
